module.exports = __webpack_public_path__ + "static/media/my-bookings.150db8e1.svg";